import { render, staticRenderFns } from "./ButtonRenderer2.vue?vue&type=template&id=38ea3598&"
import script from "./ButtonRenderer2.vue?vue&type=script&lang=js&"
export * from "./ButtonRenderer2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/agent_ai/agent-ai-builder/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('38ea3598')) {
      api.createRecord('38ea3598', component.options)
    } else {
      api.reload('38ea3598', component.options)
    }
    module.hot.accept("./ButtonRenderer2.vue?vue&type=template&id=38ea3598&", function () {
      api.rerender('38ea3598', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Editors/ButtonRenderer2.vue"
export default component.exports